import { useQuery } from 'react-query';
import request from '../helpers/request';

const getRequestServiceCompaniesStreets = async (serviceCompanyIds) => {
  const res = await request.get(
    '/Request/service_companies_streets',
    {
      serviceCompanyIds: serviceCompanyIds,
    },
    'Не удалось загрузить улицы',
    []
  );
  return res;
};

const useRequestServiceCompaniesStreets = (serviceCompanyIds, options) =>
  useQuery(
    ['streets', serviceCompanyIds],
    () => getRequestServiceCompaniesStreets(serviceCompanyIds),
    { ...options }
  );

export default useRequestServiceCompaniesStreets;
